import {Alert, alertColorsConfig} from '@esgi/ui/alert';
import {Text} from '@esgi/ui/typography';
import {AlertBody} from './components/body';
import {menuItems} from './constants';
import {FileType} from '../../types';
import {Dispatch} from 'react';
import {Reports} from '@esgi/main/kits/reports';
import {Settings} from './components/settings';

type Props = {
	onClose: VoidFunction;
	onDownload: Dispatch<FileType>;
};

export function PreviewDialog(props: Props) {
	const alertRef = Alert.useRef();
	const onClose = Alert.useClose(alertRef, props.onClose);

	return (
		<Alert
			modalManagerRef={alertRef}
			colorConfig={alertColorsConfig.neutral}
			defaultOpen={false}
		>
			<Alert.Header
				withBacklight={false}
				onCloseIconClick={onClose}
			>
				<Text size='large'>Student Detail Report</Text>
			</Alert.Header>
			<Settings/>
			<AlertBody/>
			<Alert.Footer>
				<Reports.DownloadButton
					menuItems={menuItems}
					onClick={(value) => props.onDownload(value as FileType)}
				/>
			</Alert.Footer>
		</Alert>
	);
}
